import ListView from "../view/list.js";
import ButtonView from "../view/button.js";

import FooterSocialsModel from "../model/footer-socials.js";

import {
  MOBILE_MEDIA_QUERY,
  defaultFooterSocialsModel,
  ActionType
} from "../const.js";

import {
  render,
  RenderPosition
} from "../../render/render.js";

import {
  debounce
} from "../../../utils/debounce.js";

export default class FooterSocials {
  constructor(listElement, buttonElement) {
    this._listElement = listElement;
    this._buttonElement = buttonElement;

    this._listView = null;
    this._buttonView = null;

    this._model = null;

    this._handleModelChange = this._handleModelChange.bind(this);
    this._handleWindowResize = this._handleWindowResize.bind(this);
    this._handleWindowResizeDebounced = debounce(this._handleWindowResize);
  }

  init() {
    this._listView = new ListView(this._listElement);
    this._buttonView = new ButtonView(this._buttonElement);

    this._model = new FooterSocialsModel(Object.assign(
        {},
        defaultFooterSocialsModel
    ));
    this._model.addObserver(this._handleModelChange);

    if (window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
      this._setMobile();
    }

    window.addEventListener(`resize`, this._handleWindowResizeDebounced);
  }

  _setMobile() {
    const data = this._model.getData();

    if (data.isReplaced) {
      return;
    }

    this._model.changeData(
        Object.assign(
            {},
            data,
            {
              isReplaced: true
            }
        ), ActionType.SET_MOBILE
    );
  }

  _setDefault() {
    const data = this._model.getData();

    if (!data.isReplaced) {
      return;
    }

    this._model.changeData(
        Object.assign(
            {},
            data,
            {
              isReplaced: false
            }
        ), ActionType.SET_DEFAULT
    );
  }

  _processSetDefault() {
    if (this._listView.getPreviousElement()) {
      render(this._listView.getPreviousElement(), this._listView.getElement(), RenderPosition.AFTEREND);
    }

    if (this._buttonView.getPreviousElement()) {
      render(this._buttonView.getPreviousElement(), this._buttonView.getElement(), RenderPosition.AFTEREND);
    }
  }

  _processSetMobile() {
    this._listView.setPreviousElement();
    this._buttonView.setPreviousElement();

    if (this._listView.getPreviousElement()) {
      render(this._listView.getPreviousElement(), this._buttonView.getElement(), RenderPosition.AFTEREND);
    }

    if (this._buttonView.getPreviousElement()) {
      render(this._buttonView.getPreviousElement(), this._listView.getElement(), RenderPosition.AFTEREND);
    }
  }

  _handleModelChange(action) {
    switch (action) {
      case ActionType.SET_DEFAULT:
        this._processSetDefault();
        break;
      case ActionType.SET_MOBILE:
        this._processSetMobile();
        break;
    }
  }

  _handleWindowResize() {
    if (window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
      this._setMobile();
    } else {
      this._setDefault();
    }
  }
}
